import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '~src/httpClient/RestApiService';

import { IAuthFederationKey, IGetAuthFederationKeysResponse } from '../service/AuthFederationService';

export function getAuthFederationKeysRequestConfig(): JsonRestApiRequestConfig {
  return {
    restApiVersion: '3.30',
    httpMethod: 'GET',
    // Public, unauthenticated route. The wire body is bare RFC 7517 JWKS:
    //   { "keys": [<JWK>, ...], "active_kid": "<luid>" }
    // (no tsResponse envelope.) The server returns all keys -- both active and inactive --
    // so external verifiers can validate tokens that were signed before a key was deactivated.
    endpoint: 'auth-federation/.well-known/jwks.json',
    serverWideRequest: false
  };
}

export function callGetAuthFederationKeysRequest(): Promise<IGetAuthFederationKeysResponse> {
  return makeJsonRestApiRequest<null, any>({
    config: getAuthFederationKeysRequestConfig(),
    request: null
  }).then((response) => {
    const keys: IAuthFederationKey[] = Array.isArray(response.keys) ? response.keys : [];
    return {
      keys,
      activeKid: typeof response.active_kid === 'string' ? response.active_kid : null
    };
  });
}
